import { CopyValue } from './AdminPayments';
import './AdminHelpDesk.css';

export function CopyTag({ value, prefix, label, displayText }: { value: string; prefix: string; label: string; displayText?: string }) {
  return (
    <span className="help-desk__id-tag" onClick={(event) => event.stopPropagation()}>
      <CopyValue value={value} displayText={displayText ?? `${prefix}: ${value}`} label={label} />
    </span>
  );
}

